import { VueConstructor } from 'vue';
import VueI18n from 'vue-i18n'

function prepareMessagesForLanguages( content: any, languages: string[] ) {
    const messages = {};
    languages.forEach((lang) => {
        if (content[lang]) {
            // @ts-ignore
            messages[lang] = content[lang];
        }
    })

    return messages;
}

function createI18n(Vue: VueConstructor<Vue>, options: any, content: any) {
    Vue.use(VueI18n);

    return new VueI18n({
        locale: options.defaultLanguage,
        fallbackLocale: options.defaultLanguage,
        messages: prepareMessagesForLanguages(content, options.availableLanguages)
    });
}

export default createI18n;
